<template>
  <div>
    <div>
        <div v-if="letter.id">
          <img :src="`${backEndUrl}${letter.img_url}`" alt="">
          <div>
            {{letter.title}}
          </div>
          <div>
            {{letter.translation}}
          </div>

          <div>
            <h2>Prononcuation</h2>
            <audio controls>
              <source :src="`${backEndUrl}/${letter.voice_url}`" type="audio/ogg">
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {backEndUrl} from '@/helpers/consts';
import axios from "axios";
import letters from "@/api/letters";

export default {
  name: "index",
  data() {
    return {
      letter: {},
      backEndUrl,
    }
  },
  created() {
    letters.getLetter(this.$route.params.id)
        .then(res => {
          this.letter = res.data
        })
        .catch(err => {
          console.log(err)
        })
  }
}
</script>

<style scoped>

</style>
